var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngleInput(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 22,
    viewBox: "0 0 31 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.125 6.92188C14.8906 6.6875 14.5625 6.6875 14.3281 6.92188L9.73438 11.5156C9.5 11.75 9.5 12.125 9.73438 12.3125L9.96875 12.5938C10.2031 12.8281 10.5781 12.8281 10.7656 12.5938L14 9.40625V16.4375C14 16.7656 14.2344 17 14.5625 17H14.9375C15.2188 17 15.5 16.7656 15.5 16.4375V9.40625L18.6875 12.5938C18.9219 12.8281 19.25 12.8281 19.4844 12.5938L19.7656 12.3125C19.9531 12.125 19.9531 11.75 19.7656 11.5156L15.125 6.92188ZM27.2656 10.2031C27.4062 9.73438 27.5 9.26562 27.5 8.75C27.5 5.89062 25.1094 3.5 22.25 3.5C21.4531 3.5 20.7031 3.6875 20 4.01562C18.5 1.90625 16.0156 0.5 13.25 0.5C8.79688 0.5 5.1875 4.01562 5 8.42188C2.32812 9.35938 0.5 11.8906 0.5 14.75C0.5 18.5 3.5 21.5 7.25 21.5H24.5C27.7812 21.5 30.5 18.8281 30.5 15.5C30.5 13.2969 29.2812 11.2812 27.2656 10.2031ZM24.5 20H7.25C4.34375 20 2 17.6562 2 14.75C2 12.125 3.96875 9.92188 6.54688 9.54688C6.5 9.3125 6.5 9.03125 6.5 8.75C6.5 5.04688 9.5 2 13.25 2C16.0625 2 18.4531 3.73438 19.4844 6.21875C20.1875 5.46875 21.125 5 22.25 5C24.3125 5 26 6.6875 26 8.75C26 9.64062 25.6719 10.4375 25.2031 11.0938C27.3594 11.4219 29 13.2969 29 15.5C29 17.9844 26.9844 20 24.5 20Z",
    fill: "#1A86E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleInput);
export default __webpack_public_path__ + "static/media/angle-input.6c066b16.svg";
export { ForwardRef as ReactComponent };